import { Directive, Input, OnChanges } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({
  selector: 'mat-select[aria-describedby]',
  standalone: true,
})
export class ForceAriaDescribedbyDirective implements OnChanges {
  @Input('aria-describedby') ariaDescribedby: string;

  constructor(private readonly el: MatSelect) {}
  ngOnChanges(): void {
    if (this.ariaDescribedby) {
      this.el._elementRef.nativeElement?.setAttribute(
        'aria-describedby',
        this.ariaDescribedby
      );
    }
  }
}
